var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoingoLogoDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "13.7 5.7 96.8 49.2",
    enableBackground: "new 13.7 5.7 96.8 49.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.4,31.4c-2.4,0-3.9,1-4.7,1.9v-9.8h-4.1v0.3v22.8h3.9v-1.7c1.1,1.4,2.9,2.1,4.8,2.1l0,0 c2.3,0,4.1-0.9,5.3-2.3c1.2-1.4,1.9-3.3,1.9-5.5c0-2.2-0.8-4.1-2-5.5C26.3,32.3,24.6,31.4,22.4,31.4z M21.6,35.1 c2.5,0,4,1.9,4,4.1c0,2.1-1.5,4.1-4,4.1s-4-1.9-4-4.1C17.7,37,19.1,35.1,21.6,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.6,33.5c-1.4-1.3-3.4-2.1-5.7-2.1c-2.2,0-4.2,0.8-5.7,2.1c-1.4,1.3-2.4,3.3-2.4,5.6 c0,2.3,0.9,4.3,2.4,5.6c1.4,1.3,3.4,2.1,5.7,2.1l0,0c2.2,0,4.2-0.8,5.7-2.1c1.4-1.3,2.4-3.3,2.4-5.6C48,36.9,47.1,34.9,45.6,33.5z  M36,39.1c0-2.1,1.5-4.1,4-4.1c2.5,0,4,1.9,4,4.1c0,2.1-1.5,4.1-4,4.1C37.5,43.2,36,41.3,36,39.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "50.9,32 50.9,46.6 55,46.6 55,31.7 50.9,31.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52.9,24.8c-1.4,0-2.5,1.1-2.5,2.4c0,1.2,1,2.4,2.5,2.4c1.4,0,2.6-1,2.6-2.4S54.3,24.8,52.9,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M67.2,31.4c-2.1,0-3.4,0.9-4.2,2.1v-1.8h-3.9V32v14.6h4v-8.1c0-1.8,0.9-3.4,3-3.4c1.1,0,1.7,0.6,2,1.3 c0.3,0.8,0.4,1.8,0.4,2.6v7.5h4.1v-9.2c0-1.5-0.4-3-1.2-4.1C70.6,32.1,69.2,31.4,67.2,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.7,31.7v1.7c-1.1-1.4-3-2.1-4.8-2.1c-2.3,0-4.1,0.9-5.3,2.3c-1.2,1.4-1.9,3.3-1.9,5.5 c0,2.1,0.8,4,2,5.3c1.3,1.3,3.1,2.2,5.3,2.2c1.6,0,3.3-0.6,4.5-1.7v0.5c0,1.4-0.3,2.6-1,3.3c-0.7,0.8-1.7,1.2-3.3,1.2 c-1.9,0-3.3-0.7-4.8-2l-0.2-0.2l-2.5,3.3l0.2,0.2c2.1,1.8,4.6,2.4,7.2,2.4l0,0c2.9,0,5-0.9,6.3-2.4c1.3-1.5,2-3.7,2-6.3V31.7h-0.3 H87.7z M87.7,39c0,2.3-1.5,3.9-4,4c-2.3,0-4-1.8-4-3.9c0-2.4,1.6-4,4-4C86.2,35.1,87.7,36.7,87.7,39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108.1,33.5c-1.4-1.3-3.4-2.1-5.7-2.1c-2.2,0-4.2,0.8-5.7,2.1c-1.4,1.3-2.4,3.3-2.4,5.6 c0,2.3,0.9,4.3,2.4,5.6c1.4,1.3,3.4,2.1,5.7,2.1c2.2,0,4.2-0.8,5.7-2.1c1.4-1.3,2.4-3.3,2.4-5.6C110.5,36.9,109.5,34.9,108.1,33.5 z M102.4,43.2c-2.5,0-4-1.9-4-4.1c0-2.1,1.5-4.1,4-4.1s4,1.9,4,4.1C106.4,41.3,104.9,43.2,102.4,43.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M64.2,21.3c-2.4-3.7-6.5-6.2-11.2-6.2l0,0c-4.8,0-8.9,2.5-11.2,6.2l0,0l-0.7,1L38.9,21l0.7-1 c2.9-4.5,7.8-7.3,13.4-7.3l0,0c5.6,0,10.6,3,13.4,7.3l0,0l0.7,1l-2.2,1.3L64.2,21.3L64.2,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M69.3,18c-3.4-5.4-9.5-9-16.4-9l0,0c-6.9,0-12.9,3.6-16.4,9l0,0l-0.7,1l-2.2-1.3l0.7-1 C38.3,10.6,45.2,6.5,53,6.5l0,0c7.8,0,14.7,4.1,18.6,10.2l0,0l0.7,1L70,19L69.3,18L69.3,18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M44,24.3l0.7-1c1.7-2.8,4.8-4.6,8.3-4.6l0,0c3.4,0,6.6,1.8,8.3,4.6l0,0l0.7,1l-2.2,1.3l-0.7-1 c-1.3-2-3.5-3.3-6.1-3.3l0,0c-2.6,0-4.9,1.3-6.1,3.3l0,0l0,0l-0.7,1L44,24.3L44,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M64.2,21.3c-2.4-3.7-6.5-6.2-11.2-6.2l0,0c-4.8,0-8.9,2.5-11.2,6.2l0,0l-0.7,1L38.9,21l0.7-1 c2.9-4.5,7.8-7.3,13.4-7.3l0,0c5.6,0,10.6,3,13.4,7.3l0,0l0.7,1l-2.2,1.3L64.2,21.3L64.2,21.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoingoLogoDefault);
export default __webpack_public_path__ + "static/media/boingo_logo_default.e97c57d8b5cdbc25a0fb331883a59024.svg";
export { ForwardRef as ReactComponent };